import { orderStatus, mapControl, } from '@/constants';
import { getFilteredOrderList, includedWorkerFilter, isIncludedCurrentFilter, mapControlSortOrderList, sortWorkerList, } from '@/lib/map-control/helper';
import { vuexEventPathGenerator } from '@/utils';
import getterUtil from './getterUtil';
export const getterType = {
    getterOrderList: 'getterOrderList',
    includesSelectedItemList: 'includesSelectedItemList',
    getterSelectedWorkerCode: 'getterSelectedWorkerCode',
    getterStoreList: 'getterStoreList',
    /** 라이더 단건 조회 */
    getterGetWorker: 'getterGetWorker',
    getterSelectedStoreData: 'getterSelectedStoreData',
    getterSelectedStoreOrderList: 'getterSelectedStoreOrderList',
    getterSelectedWorkerOrderList: 'getterSelectedWorkerOrderList',
    getterMainOrderList: 'getterMainOrderList',
    getterSelectedOrderCount: 'getterSelectedOrderCount',
    getterGetOrderItem: 'getterGetOrderItem',
    getterGetRelatedWorkerOrderItem: 'getterGetRelatedWorkerOrderItem',
    isMaxSelectedItem: 'isMaxSelectedItem',
    getterRelatedWorkerList: 'getterRelatedWorkerList',
    getterWorkerList: 'getterWorkerList',
    getterMainWorkerList: 'getterMainWorkerList',
    selectedItemsPosition: 'selectedItemsPosition',
    ordersPositionBySelectedStore: 'ordersPositionBySelectedStore',
    getterHasDeliveringOrder: 'getterHasDeliveringOrder',
};
export const mapControlGetterType = vuexEventPathGenerator(getterType, 'mapControl');
const positionDataBuilder = {
    _order({ orderList }, id) {
        const { dropLatitude: lat, dropLongitude: lng } = orderList[id];
        return {
            lat,
            lng,
        };
    },
    _worker({ workerList }, id) {
        const worker = workerList[id];
        if (!worker) {
            return false;
        }
        const { location: { latitude: lat, longitude: lng } } = worker;
        return {
            lat,
            lng,
        };
    },
    _store({ storeList }, id) {
        const { position: [lat, lng,] } = storeList[id];
        return {
            lat,
            lng,
        };
    },
    build(key, state, targetId) {
        try {
            return this[`_${key}`](state, targetId);
        }
        catch (error) {
            // TODO 에러 로그 작업 필요
            return console.log(error);
        }
    },
};
const getter = {
    /**
     * 상점 리스트
     * 지도 영역에서만 사용.
     */
    [getterType.getterStoreList]: ({ storeList }) => storeList,
    /**
     * 주문 1차 필터 >> 전체에서 제외할 것들 필터링
     * 리스트는 1차 필터, 2차 필터로 나뉨.
     * 주문 리스트 (공유 주문 숨김 적용)
     * 추가적 필터 지속적으로 적용 예정..
     * @param {*} param0
     * @returns {Object} 주문 리스트
     */
    [getterType.getterOrderList]: ({ orderList, mapVisibilitySetting }) => {
        const result = {};
        const { isHideShareOrder, } = mapVisibilitySetting;
        Object.values(orderList).forEach((order) => {
            // 공유주문 접수건은 제외
            if (order.isShareOrder
                && isHideShareOrder
                && order.isAccepted) {
                return;
            }
            // 배차 건의 경우 내 소속 허브 라이더에게 배차되지 않은 공유주문이면 숨기기
            if (order.allocatedWorkerCode
                && order.isShareOrderAndNotMyWorker()) {
                return;
            }
            result[order.orderId] = order;
        });
        return result;
    },
    [getterType.getterSelectedWorkerCode]: ({ selectedWorker }) => selectedWorker?.user?.code,
    /**
     * 선택된 스토어 데이터
     */
    [getterType.getterSelectedStoreData]: (state) => state.storeList[state.selectedStoreId] ?? {},
    /**
     * 2차 필터
     * 1차 필터를 이용해서 처리. getterOrderList
     * 선택된 상점 주문 목록
     * (중요) 주문 리스트는 orderList를 이용해서 처리해야 함.
     * storeList는 reactivaty가 일어나지 않음
     */
    [getterType.getterSelectedStoreOrderList]: ({ searchOrderQuery, selectedOrderFilter, selectedStoreId, }, { getterOrderList }) => {
        if (!selectedStoreId) {
            return {};
        }
        // reactivity를 위해 storeList가 아닌 orderList로 처리 필요.
        let result = getterOrderList;
        // 검색 결과
        result = getterUtil.getOrdersWithSearchQuery(result, searchOrderQuery);
        // 배달 필터 결과
        result = getFilteredOrderList(result, selectedOrderFilter, 
        // 선택한 상점의 주문 유무
        (order) => selectedStoreId && order.storeId === selectedStoreId);
        // 정렬
        return mapControlSortOrderList(result);
    },
    /**
     * 2차 필터
     * 선택된 라이더 배차건 목록
     */
    [getterType.getterSelectedWorkerOrderList]: ({ selectedWorkerOrderList, mapVisibilitySetting, searchOrderQuery, selectedWorker, }) => {
        const result = {};
        Object.values(selectedWorkerOrderList).forEach((order) => {
            if (mapVisibilitySetting.isHideShareOrder
                && order.isShareOrderAndNotMyWorker()) {
                return;
            }
            result[order.orderId] = order;
        });
        // 검색 결과
        const resultSearchQuery = getterUtil.getOrdersWithSearchQuery(result, searchOrderQuery);
        // 라이더 필터 결과 (배달필터 무시 작업으로 인해 필터는 항시 ALL로 고정)
        const resultWorkerFilter = getFilteredOrderList(resultSearchQuery, [
            mapControl.orderStatusGroupList.ALL.code,
        ], (order) => {
            if ((!order.isAccepted && selectedWorker?.user)
                && order.allocatedWorkerCode === selectedWorker.user.code) {
                return true;
            }
            return false;
        });
        // 정렬
        return mapControlSortOrderList(resultWorkerFilter);
    },
    /**
     * 2차 필터 >> 해당 영역에서만 제외할 것들 필터
     * 상태 필터 + 연관 주문 제외 리스트
     * @param {*} state
     * @returns
     */
    [getterType.getterMainOrderList]: ({ searchOrderQuery, selectedOrderFilter, selectedStoreId, selectedWorker, }, getters) => {
        const searchOrderQueryResult = getterUtil.getOrdersWithSearchQuery(getters.getterOrderList, searchOrderQuery);
        const result = getFilteredOrderList(searchOrderQueryResult, selectedOrderFilter, (order) => {
            // TODO 추후 성능 개선 비교 필요
            if (!order) {
                return false;
            }
            // 선택한 상점의 주문건 제외
            if (selectedStoreId && order.storeId === selectedStoreId) {
                return false;
            }
            // 선택한 라이더가 배차한 주문일 경우
            if (!order.isWorkerRequested
                && !order.isAccepted
                && selectedWorker?.user
                && order.allocatedWorkerCode === selectedWorker.user.code) {
                return false;
            }
            return true;
        });
        // 정렬
        return mapControlSortOrderList(result);
    },
    [getterType.getterSelectedOrderCount]: (state) => Object.keys(state.selectedOrderItemsObj).length,
    /**
     * 특정 주문 추출 (필터 된 데이터 기준)
     */
    [getterType.getterGetOrderItem]: (state, getters) => (orderId) => (getters.getterMainOrderList.find((order) => String(order.orderId) === String(orderId))),
    /**
     * 라이더 배차건에서 특정 주문 조회
     */
    [getterType.getterGetRelatedWorkerOrderItem]: (state, getters) => (orderId) => (getters.getterSelectedWorkerOrderList.find((order) => String(order.orderId) === String(orderId))),
    /**
     * 선태된 항목에 포함되는지 여부
     */
    [getterType.includesSelectedItemList]: (state) => (orderId) => (Object.keys(state.selectedOrderItemsObj).some((key) => (String(key) === String(orderId)))),
    /**
     * 선택할 수 있는 최대치 여부
     * @returns Boolean
     */
    [getterType.isMaxSelectedItem]: (state) => {
        // 배달 요청 선택 최대치
        const LIMIT = mapControl.SELECT_ORDER_MAX_COUNT;
        return Object.keys(state.selectedOrderItemsObj).length >= LIMIT;
    },
    /**
     * 워커 2차 필터
     * 워커 패널 연관 리스트 (선택한 주문의 라이더)
     * @param {*} state
     * @returns
     */
    [getterType.getterRelatedWorkerList]: ({ relatedWorkerList, selectedWorkerFilter, }) => {
        const result = {};
        Object.entries(relatedWorkerList).forEach(([key, workerData,]) => {
            if (includedWorkerFilter(workerData, selectedWorkerFilter)) {
                result[key] = workerData;
            }
        });
        return result;
    },
    /**
     * 워커 1차 필터
     * @returns
     */
    [getterType.getterWorkerList]: ({ searchWorkerQuery, workerList, selectedWorkerFilter, mapVisibilitySetting, }) => {
        const { isHideShareWorker, } = mapVisibilitySetting;
        const result = {};
        Object.entries(workerList).forEach(([key, workerData]) => {
            const { user: { name, }, isShareWorker, } = workerData;
            // 공유 라이더 숨김 채크
            if (isShareWorker && isHideShareWorker) {
                return;
            }
            // 필터 채크
            if (!includedWorkerFilter(workerData, selectedWorkerFilter)) {
                return;
            }
            // 검색어와 다르면 숨김
            if (!name.toLowerCase().includes(searchWorkerQuery.toLowerCase())) {
                return;
            }
            result[key] = workerData;
        });
        return result;
    },
    /**
     * 워커 2차 필터
     * 워커 메인 패널 리스트
     * TODO 개선 필요..
     * @returns
     */
    [getterType.getterMainWorkerList]: (state, { getterWorkerList, }) => {
        const result = {};
        Object.entries(getterWorkerList).forEach(([key, workerData]) => {
            // 가중치가 있는 것 제외 (연관 라이더에 해당 됨)
            if (workerData.relatedWeight && workerData.relatedWeight > 0) {
                return;
            }
            result[key] = workerData;
        });
        // 정렬
        return sortWorkerList(result);
    },
    /**
     * 현재 선택된 항목들 포지션
     */
    [getterType.selectedItemsPosition]: (state) => {
        const { selectedOrderItemsObj, selectedWorker, } = state;
        const result = [];
        const targetIds = {
            order: new Set(),
            worker: new Set(),
            store: new Set(),
        };
        // 주문, 상점 데이터 취합
        Object.values(selectedOrderItemsObj).forEach(({ orderId, allocatedWorkerCode, storeId, }) => {
            targetIds.order.add(orderId);
            targetIds.store.add(storeId);
            if (allocatedWorkerCode) {
                targetIds.worker.add(allocatedWorkerCode);
            }
        });
        // 라이더 데이터 취합
        Object.values([
            selectedWorker,
        ]).forEach((workerData) => {
            if (!workerData) {
                return;
            }
            const { user: { code, }, orderInfo, } = workerData;
            orderInfo.forEach(({ orderId, statusCode, storeId, }) => {
                // TODO 워커 주문 배달내역에서 채크 로직 (워커 주문을 배달내역 기준으로 변경 리팩토링 필요)
                const orderData = state.orderList[orderId];
                if (!orderData) {
                    return;
                }
                targetIds.store.add(storeId);
                // 완료건은 처리 안함
                if (statusCode === orderStatus.DROP_FINISHED.code) {
                    return;
                }
                targetIds.order.add(orderId);
            });
            targetIds.worker.add(code);
        });
        // 좌표 수집
        Object.entries(targetIds).forEach(([key, context,]) => {
            context.forEach((targetId) => {
                const targetPositionObject = positionDataBuilder
                    .build(key, state, targetId);
                if (!targetPositionObject) {
                    return;
                }
                result.push(targetPositionObject);
            });
        });
        return result;
    },
    /**
     * 특정 상점에 속한 주문들 배송지 위치
     */
    [getterType.ordersPositionBySelectedStore]: ({ selectedOrderFilter, storeList, selectedStoreId, mapVisibilitySetting, }) => {
        const { isHideShareOrder, } = mapVisibilitySetting;
        if (!storeList[selectedStoreId]) {
            return [];
        }
        const store = storeList[selectedStoreId];
        const result = [];
        result.push({
            lat: store.position[0],
            lng: store.position[1],
        });
        return Object.values(store.items)
            .reduce((acc, { dropLatitude: lat, dropLongitude: lng, statusCode, isShareOrder, isAccepted, }) => {
            // 공유접수상태 채크
            if (isShareOrder && isHideShareOrder && isAccepted) {
                return acc;
            }
            // 지도영역에 없으면 제외
            if (!isIncludedCurrentFilter(statusCode, selectedOrderFilter)) {
                return acc;
            }
            acc.push({
                lat,
                lng,
            });
            return acc;
        }, result);
    },
    [getterType.getterGetWorker]: (state) => (workerCode) => state.workerList[workerCode],
    /**
     * 선택한 주문에 라이더 정보가 있는지 여부
     * @param state
     */
    [getterType.getterHasDeliveringOrder]: (state) => Object.values(state.selectedOrderItemsObj).some(({ statusCode }) => statusCode !== orderStatus.ACCEPTED.code),
};
export default getter;
